<template>
    <span>
        <button v-if="disclosureTokens" :id="disclosurBtnId" :data-target="disclosureIdTrigger" :target="target" class="disclosure-link a11y-modal-trigger">{{ disclosureText }}</button>
        <a11y-modal :id="disclosureIdTrigger">
            <template #h4> {{ DisclosureHeadingText }} </template>
            <div slot="body" class="disclosures-section" v-html="ModalBody"></div>
        </a11y-modal>
    </span>
</template>

<script>
    import a11yModal from '../helpers/a11y-modal';
    import A11yModal from './a11y-modal.vue';
    import wwwUrlEnv from '../helpers/www-url-env';
    import makeHttpRequest from '../helpers/ajax';

    export default {
        props: {
            disclosureText: {
                default: 'Advertising Disclosures',
            },
            disclosurePreText: {
                default: '',
            },
            disclosureTokens: {
                default: '',
            },
            openDisclosureModal: {
                default: false,
            },
            disclosureId: {
                type: String,
                default: 'disclosure',
            },
            disclosureHeadingText: {
                default: 'Advertising Disclosures',
            },
        },

        data() {
            return {
                ShowModal: false,
                ModalBody: '',
                target: '',
                DisclosureHeadingText: '',
                disclosureIdTrigger: `${this.disclosureId}_btn_${(Math.random() + 1).toString(36).substring(7)}`,
                disclosurBtnId: `${this.disclosureId}_btn_${(Math.random() + 1).toString(36).substring(7)}`,

            };
        },
        components: {
            A11yModal,
        },
        methods: {
            fetchData() {
                this.ModalBody = '';
                if (typeof this.disclosureTokens !== 'undefined') {
                    // Removed 0 from Token starting
                    let tokens = this.disclosureTokens.split(',');
                    Object.keys(tokens).forEach((key) => {
                        if (tokens[key]) tokens[key] = parseInt(tokens[key], 10);
                    });
                    tokens.push('default');
                    tokens = tokens.join(',');

                    const url = `${wwwUrlEnv.getWWWURL()}/wp-json/wp/v2/disclosure?slug=${tokens}`;
                    const request = {
                        url,
                        storage_key: this.disclosureTokens,
                        expTime: 15 * 60 * 1000,
                        headers: { 'x-requested-with': 'XMLHttpRequest' },
                    };
                    return makeHttpRequest(request).then((response) => {
                        const disclosureData = JSON.parse(response);
                        tokens.split(',').forEach((disclosureNumber) => {
                            let disclosure = {};
                            Object.keys(disclosureData).forEach((key) => {
                                if (disclosureData[key].slug === disclosureNumber) disclosure = disclosureData[key];
                            });
                            if (disclosure && disclosure.content && disclosure.content.rendered && disclosure.acf && disclosure.acf.header !== 'Not Found') {
                                if (disclosureNumber !== 'default') {
                                    this.ModalBody += `<label class="disclosure-number">Disclosure ${disclosureNumber}</label>`;
                                }
                                this.ModalBody += `<label class="details-title">${disclosure.acf.header}</label>`;
                                this.ModalBody += `<div class="disclosure-post">${disclosure.content.rendered}</div><span class="divider"></span>`;
                            } else {
                                this.ModalBody = '<h3>Advertising Disclosures Not found.</h3>';
                            }
                        });
                    }, (error) => {
                        console.warn(`There is some issue with network call, please try again: ${error}`);
                    });
                }
                return false;
            },
        },
        mounted() {
            if (this.fetchData()) {
                a11yModal.initModal();
                this.DisclosureHeadingText = this.disclosureHeadingText;
            }
        },
    };
</script>

<style lang="scss">
    .a11y-modal {
        .a11y-modal-dialog {
            max-width: 900px;
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            margin: 0 auto;
            border-radius: 5px;

            .a11y-modal-header {
                h2 {
                    color: #101f30;
                    font-size: 27px;
                    font-weight: 400;
                    display: inline-block;
                    border: none;
                }
            }

            .disclosures-section {
                color: #454545;

                .details-title {
                    display: block;
                    margin-bottom: 15px;

                    p {
                        font-size: 20px;
                        font-weight: normal;
                        margin: 0 0 20px;
                    }
                }

                .disclosure-number {
                    color: #101f30;
                    font-size: 30px;
                    font-weight: bold;
                    margin-bottom: 15px;
                    display: inline-block;
                }

                .divider {
                    margin: 20px 0;
                    display: block;
                    border-bottom: 1px solid #ddd;

                    &:last-child {
                        display: none;
                    }
                }

                .disclosure-post {
                    font-size: 16px;
                    line-height: 1.8em;

                    p {
                        @extend .disclosure-post;
                    }
                }
                ul {
                    padding-left: 30px;

                    li {
                        color: #454545;
                        line-height: 1.6em;
                        padding-left: 32px;
                        margin-top: 0;
                    }
                }
            }
        }
    }
</style>
<style src="../../assets/styles/a11yModal.scss" lang="scss"></style>
